export default __webpack_public_path__ + "static/media/raza.31f444cc.webp";